//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'unison';

import { ExitConfirmationModalActions } from '@catalog-ingestion/actions/exitConfirmationModalActions';
import { GoogleCatalogIngestionModalActions } from '@catalog-ingestion/actions/googleCatalogIngestionModalActions';
import {
  FlatDefaultButton,
  PrimaryButton,
} from '@components/atoms/button/Button';

export const ExitConfirmationModal = () => {
  const dispatch = useDispatch();

  const { isOpen } = useSelector(
    (state) => state.catalogIngestionReducers.exitConfirmationModal,
  );

  const { closeExitConfirmationModal } = ExitConfirmationModalActions;
  const { resetAndCloseWorkflow } = GoogleCatalogIngestionModalActions;

  return (
    <StyledModal isOpen={isOpen}>
      <ModalHeader onCancel={() => dispatch(closeExitConfirmationModal())}>
        Are you sure you want to exit?
      </ModalHeader>
      <StyledModalBody>Your changes will not be saved.</StyledModalBody>
      <ButtonContainer>
        <CancelButton onClick={() => dispatch(closeExitConfirmationModal())}>
          Cancel
        </CancelButton>
        <PrimaryButton onClick={resetAndCloseWorkflow}>Exit</PrimaryButton>
      </ButtonContainer>
    </StyledModal>
  );
};

const CancelButton = styled(FlatDefaultButton)`
  && {
    margin-right: ${({ theme }) => theme.spacings[2]};
  }
`;

const ButtonContainer = styled(ModalFooter)`
  style: flex;
  justify-content: end;
`;

const StyledModal = styled(Modal)(
  ({ theme }) => `
  && {
    .cu-modal-body-container {
      margin-bottom: ${theme.spacings[2]};
      padding: 0 ${theme.spacings[4]} !important;
    }
    .cu-modal-closer {
      margin-left: ${theme.spacings[4]};
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`,
);

const StyledModalBody = styled(ModalBody)(
  ({ theme }) => `
  display: block;
  width: ${theme.wideMeasure};
`,
);
